import { Route, Routes, Navigate } from "react-router-dom";
import { React } from "react";
import { MasterLayout } from "../module/common/components/MasterLayout";
import { HomeWrapper } from "../page/home/HomeWrapper";

const PrivateRoutes = () => {
  return (
    <>
      <Routes>
        <Route element={<MasterLayout />}>
          <Route path="home/*" element={<HomeWrapper />} />
          <Route path="*" element={<Navigate to={"/home"} />} />
        </Route>
      </Routes>
    </>
  );
};

export { PrivateRoutes };
